<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="end">
        <ion-button @click="cerrar">
          <i class="icon ion-ios-close-circle-outline"></i>
        </ion-button>
      </ion-buttons>
      <ion-title>Tipo de equipo ({{tipos.length}})</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-searchbar placeholder="Buscar por nombre, email o RFC" v-on:ionChange="filtrar($event.detail.value)" debounce="500"></ion-searchbar>
    <ion-list>
      <ion-item v-for="e in tiposFiltrados" :key="e._id" @click="seleccionartipo(e)">
        <ion-label>
          <h2>{{e}}</h2>
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-app>
</template>

<script>
import Api from '@/components/Api/Api'
import TiposEquipos from '@/models/TiposEquipos.vue'
export default {
  name: 'ModalSeleccionarTipoEquipo',
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      tipos: [],
      tiposFiltrados: []
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    cerrar() {
      console.log("$emit cerrarModal")
      Api.$emit('ModalSeleccionarTipoEquipoCerrar')
    },
    seleccionartipo(e) {
      Api.$emit('seleccionarTipoEquipo', e)
    },
    filtrar(str) {
      str = (str || '').toUpperCase()
      this.tiposFiltrados = this.tipos
        .filter(e => (e || '').toUpperCase().indexOf(str) >= 0)
    }
  },
  async mounted() {
    this.tipos = (await TiposEquipos.obtener()).sort((a, b) => a > b ? 1 : -1)
    console.log("ModalSeleccionarTipoEquipo", this.tipos.length, this.tipos)
    this.filtrar('')
  }
}
</script>
